<template>
  <nav class="main-menu">
    <ul class="main-menu-list">
      <li class="main-menu-list__item" v-for="route in routes" :key="route.name">
        <MobileMenuButton
          :route="route"
          :subitems="route.subitems"
          :active-group="activeGroup"
          @change-active-group="handleChangeActiveGroup"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
import MobileMenuButton from '../mobile-menu-button';

export default {
  props: {
    routes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeGroup: '',
    };
  },
  components: { MobileMenuButton },
  methods: {
    handleChangeActiveGroup(activeGroup) {
      if (this.activeGroup !== activeGroup) {
        this.activeGroup = activeGroup;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-menu-list {
  padding-bottom: 70px;

  &__item {
    &:nth-child(n+2) {
      margin-top: 8px;
    }
  }
}

</style>
